/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import {
  notSelectedVariantCardStyle,
  root,
  selectedVariantCardStyle,
  variantCardStyle,
  variantStyle,
} from "./variantStyle";

import type { VariantProps } from "./variantProps";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

const EMPTY_ARRAY_COUNT = 0;

export const Variant: FcWithoutChildren<VariantProps> = (props) => {
  const { handleSelectVariant, selectedVariantId, variantCategories } = props;

  if (variantCategories.length === EMPTY_ARRAY_COUNT) return null;

  return (
    <ul css={root}>
      {variantCategories.map(([classId, variantCategory]) => {
        return (
          <li key={classId}>
            <ul css={variantStyle}>
              {variantCategory.map((variant) => {
                const { class: classId, subClass, subClassName } = variant;
                if (classId === undefined) return null;

                const isSelected = subClass === selectedVariantId;

                const labelStyles = [
                  variantCardStyle,
                  isSelected
                    ? selectedVariantCardStyle
                    : notSelectedVariantCardStyle,
                ];
                const handleChange = () => handleSelectVariant(subClass);

                return (
                  <li key={subClass}>
                    <label css={labelStyles}>
                      <span>{subClassName}</span>
                      <input
                        name={classId.toString()}
                        type="radio"
                        value={subClass}
                        onChange={handleChange}
                      />
                    </label>
                  </li>
                );
              })}
            </ul>
          </li>
        );
      })}
    </ul>
  );
};
